const baseForm = {
  target: {
    name: '',
    employeeCode: null,
    jobTitle: '',
  },
  date: null,
  products: [],
  quantityDetails: [],
  quantityDetailsDefault: {
    volume: null,
    requestsNumber: null,
    onlineRequestsNumber: null,
  },
}

export const state = () => ({
  products: [],
  form: baseForm,
  loadingEditItem: null,
  coordinators: [],
  salesmen: [],
})

const formatProductsGoalsToEdit = payload => {
  payload.products.forEach(item => {
    Object.assign(item, { defaultGoal: null })
  })
  payload.quantityDetailsDefault = {
    volume: null,
    requestsNumber: null,
    onlineRequestsNumber: null,
  }
  return payload
}

const formatProductsGoalsToSubmit = payload => {
  delete payload.quantityDetailsDefault
  payload.products.forEach(item => {
    delete item.defaultGoal
  })
  return payload
}

const formatProducts = (products, employees) => {
  return products.map(item => ({
    product: { ...item },
    goals: employees.map(item => ({
      salesman: { ...item },
      goal: null,
    })),
    defaultGoal: null,
  }))
}

export const mutations = {
  setSalesmen: (state, value) => (state.salesmen = value),
  setCoordinators: (state, value) => (state.coordinators = value),
  setProducts: (state, value) => (state.products = value),
  setForm: (state, value) => {
    state.form = value
  },
  setFormProducts: (state, value) => (state.form.products = value),
  setLoadingEditItem: (state, value) => (state.loadingEditItem = value),
  setDefaultGoal(state, { productCode, value }) {
    const product = state.form.products.find(
      item => item.product.code === productCode
    )
    product.goals = product.goals.map(item => ({ ...item, goal: value }))
    product.defaultGoal = value
  },
  setIndividualGoal(state, { productCode, employeeCode, value }) {
    const product = state.form.products.find(
      item => item.product.code === productCode
    )
    const goal = product.goals.find(
      item => item.salesman.employeeCode === employeeCode
    )
    goal.goal = value
  },
  setIndividualQuantity(state, { key, value, employeeCode }) {
    const salesman = state.form.quantityDetails.find(
      item => item.salesman.employeeCode === employeeCode
    )
    if (!salesman) return
    salesman[key] = value
  },
  setDefaultQuantityDetail(state, { key, value }) {
    state.form.quantityDetailsDefault[key] = value
    state.form.quantityDetails.forEach(item => {
      item[key] = value
    })
  },
  removeProduct(state, productCode) {
    state.form.products = state.form.products.filter(
      ({ product }) => product.code !== productCode
    )
  },
}

export const actions = {
  async fetchCoordinators({ commit }, target) {
    const { data: coordinators } = await this.$axios.get(
      '/v3/app/productsGoals/coordinators',
      {
        params: { managerCode: target.employeeCode },
      }
    )
    commit('setCoordinators', coordinators)
  },
  async fetchSalesmen({ commit }, target) {
    const { data: salesmen } = await this.$axios.get(
      '/v3/app/productsGoals/salesmen',
      {
        params: { coordinatorCode: target.employeeCode },
      }
    )
    commit('setSalesmen', salesmen)
  },
  async getTargetEmployees({ state, dispatch }, target) {
    const jobTitle = target?.jobTitle || ''
    if (/coordenador/i.test(jobTitle)) {
      await dispatch('fetchSalesmen', target)
      return state.salesmen
    }
    await dispatch('fetchCoordinators', target)
    return state.coordinators
  },
  async setInitialForm({ commit, dispatch }, { target, date, products }) {
    console.log(target)
    const targetEmployees = await dispatch('getTargetEmployees', target)
    const formattedProducts = formatProducts(products, targetEmployees)
    const formattedQuantityDetails = targetEmployees.map(employee => ({
      salesman: employee,
      volume: null,
      requestsNumber: null,
      onlineRequestsNumber: null,
    }))
    commit('setForm', {
      target,
      date,
      products: formattedProducts,
      quantityDetails: formattedQuantityDetails,
      quantityDetailsDefault: {
        volume: null,
        requestsNumber: null,
        onlineRequestsNumber: null,
      },
    })
  },
  async addProducts({ state, commit, dispatch }, products) {
    const isCoordinator = state.form.target?.jobTitle && /coordenador/i.test(state.form.target.jobTitle)
    let targetEmployees = isCoordinator ? state.salesmen : state.coordinators
    if (targetEmployees.length === 0) {
      targetEmployees = await dispatch('getTargetEmployees', state.form.target)
    }
    const productsCode = new Set()
    state.form.products.forEach(item => productsCode.add(item.product.code))
    const additionalProducts = products.filter(
      product => !productsCode.has(product.code)
    )
    commit('setFormProducts', [
      ...state.form.products,
      ...formatProducts(additionalProducts, targetEmployees),
    ])
  },
  async submitCreateProductsGoals({ state, commit }) {
    await this.$axios.post('/v3/app/productsGoals', state.form)
    commit('setForm', baseForm)
  },
  async submitEditProductsGoals({ state, commit }) {
    await this.$axios.post(
      `/v3/app/productsGoals/edit/${state.form._id}`,
      formatProductsGoalsToSubmit(state.form)
    )
    commit('setForm', baseForm)
  },
  async setEditForm({ state, commit }, id) {
    if (state.loadingEditItem !== null) return false
    commit('setLoadingEditItem', id)
    const { data } = await this.$axios.get(`/v3/app/productsGoals/one/${id}`)
    commit('setForm', formatProductsGoalsToEdit(data))
    commit('setLoadingEditItem', null)
    return true
  },
}
